export default {
  ctrlCaption: "流程信息",
  props: {
    caption: {
      type: String,
      default() {
        return "wfinfo";
      },
    },
    chooseFlow: {
      type: Object,
      default() {
        return {};
      },
    },
    sWFID: {
      type: String,
      default() {
        return "";
      },
    },
    sObjectID: {
      type: String,
      default() {
        return "";
      },
    },
    sObjectName: {
      type: String,
      default() {
        return "";
      },
    },
    sPID: {
      type: String,
      default() {
        return "";
      },
    },
    sCurLinkID: {
      type: String,
      default() {
        return "";
      },
    },
    sCurNodeID: {
      type: String,
      default() {
        return "";
      },
    },
    sOpinion: {
      type: String,
      default() {
        return "";
      },
    },
    sExInfos: {
      type: String,
      default() {
        return "";
      },
    },
    sLineIDs: {
      type: String,
      default() {
        return "";
      },
    },
    sReceivers: {
      type: String,
      default() {
        return "";
      },
    },
    eventName: {
      type: String,
      default() {
        return "";
      },
    },
    countDown: {
      type: String,
      default() {
        return "3";
      },
    },
    linkData: {
      type: Array,
      default() {
        return [];
      },
    },
    forceHidden: {
      type: Boolean,
      default: true
    },
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("flow-info-meta-data");
      },
    },
  },
  data() {
    return {
      Objects: {},
    };
  },
  watch: {
    chooseFlow(val) {
      const value = {
        wf_id: val.ID,
        wf_name: val.name,
      };
      this.emitValueChange(value);
    },
  },
  computed: {},
  mounted() {
    if (this.$vm && this.$vm.flows) {
      this.$vm.flows.flowInfo = this;
    }
  },
  destroyed() { },
  methods: {
    getCurrLinkID(Objects) {
      const sCurLinkID = this.$replace(this.sCurLinkID, this.$vm);
      return sCurLinkID || Objects?.sCurLinkID || this.$route.query?.sCurLinkID || this.queryString?.sCurLinkID
    },
    linkSetChooseFlow() {
      document.querySelector("[rel='linkData'] .ds-button")?.click();
    },
    flowSend(res, targetButton, Objects) {
      const { line, IsSPSend } = targetButton;
      this.Objects = Objects;
      // 流程发送按钮
      let sWFID = this.chooseFlow.dsfa_rm_id;
      if (sWFID) {
        const sObjectName = this.$replace(this.sObjectName, this.$vm);
        sWFID = this.$replace(this.sWFID, this.$vm) || sWFID;
        const sCurNodeID = this.$replace(this.sCurNodeID, this.$vm);
        const sPID = this.$replace(this.sPID, this.$vm);
        let sOpinion = this.$replace(this.sOpinion, this.$vm);
        let sLineIDs = this.$replace(this.sLineIDs, this.$vm);
        let sObjectID = this.$replace(this.sObjectID, this.$vm);
        let sExInfos = this.$replace(this.sExInfos, this.$vm);
        let sReceivers = this.$replace(this.sReceivers, this.$vm);
        sExInfos = !sExInfos ? '' : eval('(' + sExInfos + ')');
        sOpinion = !sOpinion ? '' : eval('(' + sOpinion + ')');
        sLineIDs = !sLineIDs ? '' : eval('(' + sLineIDs + ')');
        // 增加 sExInfos
        sExInfos = sExInfos || Object.assign({}, dsf.removePoint(this.$vm.$viewData), this.$route.query);
        let ds_security_level;
        for(let key in this.$vm.$viewData) {
          if(key?.indexOf(".ds_security_level") > -1) {
            ds_security_level = this.$vm.$viewData?.[key];
          }
        }
        // return;
        // 开始发送
        let url = IsSPSend ? "wfr/startSPSend" : "wfr/startSend",
          param = {
            sWFID: sWFID,
            sObjectID: sObjectID || res._id,
            sObjectName: sObjectName || this.$vm.$refs[this.eventName]?.value || "",
            sCurNodeID: sCurNodeID || "",
            sExInfos: JSON.stringify(sExInfos),
            sReceivers: sReceivers,
            securityClassValue: ds_security_level?.value,
            securityLevelExpiryDate: ds_security_level?.expirydate
          };
        //继续发送
        if (Objects || this.$route.query.sPID || this.queryString.sPID) {
          url = IsSPSend ? "wfr/spSend" : "wfr/send";
          param = {
            sPID: sPID || Objects?.sPID || this.$route.query?.sPID || this.queryString?.sPID,
            sCurLinkID: this.getCurrLinkID(this.Objects),
            sExInfos: JSON.stringify(sExInfos),
            sReceivers: sReceivers,
            securityClassValue: ds_security_level?.value,
            securityLevelExpiryDate: ds_security_level?.expirydate
          };
        }

        if (sOpinion) {
          param.sOpinion = JSON.stringify(sOpinion);
        } else {
          // 发送时有处理意见
          if (this.$vm?.flows?.disposeIdea?.sOpinion) {
            param.sOpinion = JSON.stringify(this.$vm.flows.disposeIdea.sOpinion);
          }
          // 发送时表单意见框有处理意见
          if (this.$vm?.flows?.sOpinion?.Content || this.$vm?.flows?.sOpinion?.Attachments?.length > 0) {
            param.sOpinion = JSON.stringify(this.$vm.flows.sOpinion);
          }
        }
        if (sLineIDs) {
          param.sLineIDs = sLineIDs;
        } else {
          if (line) {
            param.sLineIDs = line.LineID;
          }
        }

        const config = {
          param: param,
          url: targetButton.flowUrl || url,
          countDown: this.countDown
        };

        dsf.flow.startSend(config);
      } else {
        this.$message("请先配置流程信息控件的'选择流程'", false);
      }
    },
  },
};
